/* status-citation.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./status-citation.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useMemo } from 'react';
import Lozenge from '@atlaskit/lozenge';
import { Pressable } from '@atlaskit/primitives/compiled';
import { HoverCard } from '@atlaskit/smart-card/hover-card';
import { SainAction, useSAINUsageCriteriaMet } from '../../../../common/controller/analytics/hooks/use-sain-usage';
import { extractUrlHostname } from '../../../../utils';
import { useAIAnswerContext } from '../../../ai-answer-context';
import { onAIAnswerSourceClick } from '../../../analytics';
var styles = {
  root: "_19itglyw _bfhk1j28 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke"
};
var convertColorAppearance = function convertColorAppearance(color) {
  switch (color) {
    case 'blue':
      return 'inprogress';
    case 'green':
      return 'success';
    case 'red':
      return 'removed';
    case 'yellow':
      return 'moved';
    case 'purple':
      return 'new';
    default:
      return 'default';
  }
};
export var StatusCitation = function StatusCitation(_ref) {
  var localId = _ref.localId,
    text = _ref.text,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'blue' : _ref$color;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent;
  var sources = commonAttributes.sources;
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var _useMemo = useMemo(function () {
      var _localId$split;
      if (!localId.includes('citation')) {
        return {};
      }
      var idx = parseInt((_localId$split = localId.split('-')) === null || _localId$split === void 0 ? void 0 : _localId$split[1]);
      return {
        source: sources[idx - 1],
        idx: idx
      };
    }, [localId, sources]),
    source = _useMemo.source,
    idx = _useMemo.idx;
  var handleClick = useCallback(function (source, idx) {
    fireAnalyticsEvent(onAIAnswerSourceClick(_objectSpread({
      sourceIndex: idx,
      isCitation: true,
      hostname: extractUrlHostname(source.url)
    }, commonAttributes)));
    fireSAINUsageEvent({
      metCriteria: SainAction.SOURCE_CLICKED,
      commonAttributes: commonAttributes
    });
    window.open(source.url, '_blank', 'noopener, noreferrer');
  }, [commonAttributes, fireAnalyticsEvent, fireSAINUsageEvent]);
  if (!!source) {
    return /*#__PURE__*/React.createElement(HoverCard, {
      url: source.url
    }, /*#__PURE__*/React.createElement(Pressable, {
      xcss: styles.root,
      onClick: function onClick() {
        handleClick(source, idx);
      }
    }, /*#__PURE__*/React.createElement(Lozenge, {
      appearance: "inprogress"
    }, idx)));
  }

  // Standard lozenge for status nodes
  return /*#__PURE__*/React.createElement(Lozenge, {
    appearance: convertColorAppearance(color)
  }, text);
};